// Route parts for backend controllers
export const GOOGLE_ROUTE_SEGMENT = 'google';
export const LINKEDIN_ROUTE_SEGMENT = 'linkedin';

// Controller base paths (without leading slash)
export const GOOGLE_AUTH_BASE = 'auth/google';
export const LINKEDIN_AUTH_BASE = 'auth/linkedin';

// Full routes for retained account/calendar flows
export const GOOGLE_CALENDAR_ROUTE = '/auth/google/connect-calendar';

// Callback routes for OAuth providers
export const GOOGLE_CALLBACK_ROUTE = '/auth/google/callback';
export const GOOGLE_CALENDAR_CALLBACK_ROUTE = '/auth/google/calendar-callback';
export const LINKEDIN_CALLBACK_ROUTE = '/auth/linkedin/callback';

// Query parameter carrying a failed settings re-authentication back to the page that started it.
// Its value is always one of OAUTH_REAUTH_ERROR, never free text, so a crafted link cannot put
// arbitrary words on the settings page.
export const OAUTH_REAUTH_ERROR_PARAM = 'oauth_reauth_error';
export const OAUTH_REAUTH_ERROR = {
  /** The provider account is not the one linked to the signed-in user. */
  AccountMismatch: 'account_mismatch',
  /** The callback did not arrive in the signed-in session that started the re-authentication. */
  SessionMismatch: 'session_mismatch',
  /** Any other provider or validation failure. */
  Failed: 'failed',
} as const;
export type OAuthReauthError = (typeof OAUTH_REAUTH_ERROR)[keyof typeof OAUTH_REAUTH_ERROR];

export function parseOAuthReauthError(value: unknown): OAuthReauthError | undefined {
  return Object.values(OAUTH_REAUTH_ERROR).find(code => code === value);
}

// Better Auth public entry and provider callback routes
export const BETTER_AUTH_EMAIL_SIGN_IN_ROUTE = '/auth/better/sign-in/email';
export const BETTER_AUTH_SESSION_ROUTE = '/auth/better/get-session';
export const BETTER_AUTH_SOCIAL_SIGN_IN_ROUTE = '/auth/better/sign-in/social';
export const BETTER_AUTH_GOOGLE_CALLBACK_ROUTE = '/auth/better/callback/google';
export const BETTER_AUTH_LINKEDIN_CALLBACK_ROUTE = '/auth/better/callback/linkedin';

// App initialization
export const APP_INIT_ROUTE = '/api/initialize';

// Health and system routes
export const HEALTH_ROUTE = '/health';

// Shared GraphQL error codes used by backend filters/guards and Apollo clients.
export const GraphQLErrorCodes = {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  FORBIDDEN: 'FORBIDDEN',
  HTTP_ERROR: 'HTTP_ERROR',
  /**
   * Primary authentication succeeded and an MFA challenge is required.
   * Not an unauthenticated/session-recovery failure: cookies and tokens
   * must not be issued, and clients must not logout or refresh.
   */
  MFA_CHALLENGE_REQUIRED: 'MFA_CHALLENGE_REQUIRED',
} as const;
